class NumberFormatter {
    constructor(fractionalDigits, fallback) {
        if (typeof(fractionalDigits) !== 'undefined' && !(Number.isInteger(fractionalDigits) && fractionalDigits >= 0)) {
            throw new TypeError('fractionalDigits must be undefined or integer greater or equal to zero');
        }

        this.fractionalDigits = fractionalDigits;
        this.fallback = fallback;
    }

    round(value) {
        const multiplier = Math.pow(10, this.fractionalDigits);
        return Math.round(value * multiplier) / multiplier;
    }

    format(value) {
        if (typeof(value) !== 'number') {
            return this.fallback;
        }

        if (!Number.isNaN(value) && typeof(this.fractionalDigits) === 'number') {
            return this.round(value);
        }

        return value;
    }
}

export default NumberFormatter;